class RereDirectBuy extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-rere-direct-buy]');
    this.label = this.querySelector('[data-rere-direct-buy-label]');
    this.message = this.querySelector('[data-rere-direct-buy-message]');
    this.messageText = this.querySelector('[data-rere-direct-buy-message-text]');
    this.cartLink = this.message?.querySelector('a');
    this.form = this.closest('form');

    const configElement = this.querySelector('[data-rere-direct-buy-config]');

    try {
      this.config = JSON.parse(configElement?.textContent || '{}');
    } catch (_error) {
      this.config = {};
    }

    this.defaultLabel = this.label?.textContent?.trim() || '';
    this.button?.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.handleClick);
  }

  handleClick = async () => {
    if (!this.button || !this.form || this.button.disabled || !this.form.checkValidity()) return;

    const variantInput = this.form.querySelector('input[name="id"]');
    const variantId = Number(variantInput?.value);

    if (!variantId) {
      this.showMessage(this.config.genericError);
      return;
    }

    this.setLoading(true);
    this.hideMessage();

    try {
      const cartResponse = await fetch(`${this.rootPath}cart.js`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      });

      if (!cartResponse.ok) throw new Error('Unable to load cart');

      const cart = await cartResponse.json();

      if (Number(cart.item_count) > 0) {
        this.showMessage(this.config.cartLimit, true);
        return;
      }

      const addResponse = await fetch(`${this.rootPath}cart/add.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: 1,
              properties: { _rere_device: 'true' },
            },
          ],
        }),
      });

      if (!addResponse.ok) {
        const error = await addResponse.json().catch(() => ({}));
        throw new Error(error.description || error.message || 'Unable to add item');
      }

      window.location.assign(`${this.rootPath}checkout`);
    } catch (error) {
      console.error('[ReRe direct buy]', error);
      this.showMessage(this.config.genericError);
    } finally {
      this.setLoading(false);
    }
  };

  get rootPath() {
    const root = window.Shopify?.routes?.root || '/';
    return root.endsWith('/') ? root : `${root}/`;
  }

  setLoading(isLoading) {
    if (!this.button || !this.label) return;

    this.button.disabled = isLoading;
    this.button.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    this.label.textContent = isLoading ? this.config.loading || this.defaultLabel : this.defaultLabel;
  }

  showMessage(text, showCartLink = false) {
    if (!this.message || !this.messageText) return;

    this.messageText.textContent = text || this.config.genericError || '';
    this.message.hidden = false;
    if (this.cartLink) this.cartLink.hidden = !showCartLink;
  }

  hideMessage() {
    if (this.message) this.message.hidden = true;
  }
}

if (!customElements.get('rere-direct-buy')) {
  customElements.define('rere-direct-buy', RereDirectBuy);
}
